import {UPDATE_SOCIETIES, UPDATE_ROLES, UPDATE_SERVER_STATUS} from '../types'

export const updateSocieties = (payload) => ({type: UPDATE_SOCIETIES, payload})
export const updateRoles = (payload) => ({type: UPDATE_ROLES, payload})
export const updateServerStatus = (payload) => ({type: UPDATE_SERVER_STATUS, payload})
